import { Link } from "react-router-dom";

export const LegalLayout = ({ title, updated, intro, sections, testid }) => {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16" data-testid={testid}>
      <div className="mb-10 border-b border-zinc-200 dark:border-white/10 pb-8">
        <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#FF3B30] mb-3">// Legal</div>
        <h1 className="font-display font-black uppercase tracking-tighter text-4xl sm:text-5xl text-zinc-900 dark:text-white">
          {title}
        </h1>
        <p className="mt-4 text-sm font-mono text-zinc-500">Last updated: {updated}</p>
        {intro && (
          <p className="mt-6 text-base text-zinc-600 dark:text-zinc-300 leading-relaxed">{intro}</p>
        )}
      </div>

      <div className="space-y-10">
        {sections.map((s, i) => (
          <section key={i} data-testid={`legal-section-${i}`}>
            <h2 className="font-display font-bold uppercase tracking-tight text-lg text-zinc-900 dark:text-white mb-3">
              {`${i + 1}. ${s.heading}`}
            </h2>
            <div className="space-y-3 text-sm sm:text-base text-zinc-600 dark:text-zinc-400 leading-relaxed">
              {(Array.isArray(s.body) ? s.body : [s.body]).map((p, j) => (
                <p key={j}>{p}</p>
              ))}
              {s.list && (
                <ul className="list-disc pl-6 space-y-1.5">
                  {s.list.map((li, k) => (
                    <li key={k}>{li}</li>
                  ))}
                </ul>
              )}
            </div>
          </section>
        ))}
      </div>

      <div className="mt-14 border-t border-zinc-200 dark:border-white/10 pt-8 text-sm font-mono text-zinc-500">
        <p>
          Questions about this policy? Email{" "}
          <a href="mailto:support@ilfal.com" className="text-[#00B8CC] dark:text-[#00E5FF] hover:text-[#FF3B30] transition-colors">
            support@ilfal.com
          </a>
          .
        </p>
        <div className="mt-4 flex flex-wrap gap-x-6 gap-y-2">
          <Link to="/terms" className="hover:text-[#FF3B30] transition-colors">Terms of Service</Link>
          <Link to="/privacy" className="hover:text-[#FF3B30] transition-colors">Privacy Policy</Link>
          <Link to="/refund-policy" className="hover:text-[#FF3B30] transition-colors">Refund Policy</Link>
        </div>
      </div>
    </div>
  );
};
